module.exports = __webpack_public_path__ + "img/no-data.dcc3bc31.png";